import md from '@/routes/middlewares';

import ComponentPage from '@/views/ComponentPage.vue';
import AnalysisTypePage from '@/views/AnalysisTypePage.vue';
import MeasureHistory from '@/components/nodes/MeasureHistory.vue';

const component = {
    path: 'components/:componentId',
    component: ComponentPage,
    meta: {
        middlewares: [
            md.getComponentInfo,
        ],
    },
    children: [
        {
            path: 'analysisTypes/:analysisTypeId',
            component: AnalysisTypePage,
            redirect: { name: 'history' },
            meta: {
                middlewares: [
                    md.getAnalysisTypeInfo,
                ],
            },
            children: [
                {
                    path: 'history',
                    name: 'history',
                    component: MeasureHistory,
                },
            ],
        },
    ],
};

export default component;
